import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "1 3 28 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20.5 3c-.652 0-1.202.419-1.408 1H16a1 1 0 1 0 0 2h3.434C20.02 7.392 21 9.992 21 12c0 4-3 6-5 6h-2a2 2 0 0 1-2-2v-2H4s-3 1-3 4c.36.118 1.307.524 2.389 1C2.546 19.735 2 20.803 2 22c0 2.197 1.803 4 4 4s4-1.803 4-4c0-.017-.006-.033-.006-.05.145.032.294.05.445.05h7.319c.796 0 1.559-.316 2.12-.879L20 21h.145A3.923 3.923 0 0 0 20 22c0 2.197 1.803 4 4 4s4-1.803 4-4c0-.483-.1-.941-.26-1.371L29 20s-1.389-2.846-4.268-3.732L25 16c-.06-3.705-2.174-8.069-3.326-10H23V3h-2.5zM4 10a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H4zm1.693 10.031c.81.367 1.333.605 2.006.914A2 2 0 0 1 8 22c0 1.116-.884 2-2 2s-2-.884-2-2c0-1.011.727-1.823 1.693-1.969zM22.271 21h3.458c.168.294.271.632.271 1 0 1.116-.884 2-2 2s-2-.884-2-2c0-.368.103-.706.271-1z" }, null, -1)
  ])))
}
export default { render: render }